import { createContext, useContext, useMemo, useState } from "react";

const DEFAULT_ACCENT = "#E8C98A";
const DEFAULT_GLOW = "rgba(201,162,39,0.28)";

const ServiceThemeContext = createContext({
  active: null,
  setActive: () => {},
  accent: DEFAULT_ACCENT,
  glow: DEFAULT_GLOW,
});

export function ServiceThemeProvider({ children }) {
  const [active, setActive] = useState(null);
  const value = useMemo(
    () => ({
      active,
      setActive,
      accent: active ? active.accent : DEFAULT_ACCENT,
      glow: active ? active.glow : DEFAULT_GLOW,
    }),
    [active]
  );
  return (
    <ServiceThemeContext.Provider value={value}>
      {children}
    </ServiceThemeContext.Provider>
  );
}

export const useServiceTheme = () => useContext(ServiceThemeContext);
